import FusePageCarded from '@fuse/core/FusePageCarded';
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from 'react';
import FuseLoading from '@fuse/core/FuseLoading';
import axios from "@fuse/utils/axios";
import reducer from '../store';
import withReducer from 'app/store/withReducer';
import { usePusher } from '@fuse/hooks';
import useCurrentUser from '@fuse/hooks/useCurrentUser';
import ListView from './listView';

const useStyles = makeStyles({
	layoutRoot: {
		background:'#fcfcfc'
	},
	pullRight:{
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "flex-end"
	},
	buttonContainer:{
		display: 'flex',
		flexDirection: 'row'
	},
	buttonSquare:{
		borderRadius: '5px'
	},
	topBg:{
		background:'#fcfcfc'
	},
	contentCard:{
		marginBottom:"15px",
		borderRadius:"5px"
	}
});

function CardedFullWidth2TabbedSample(props) {
	const classes = useStyles();
	const [loading, setLoading] = useState(false);
	const [selectedTab, setSelectedTab] = useState(0);
	const [serviceTemplate, setServiceTemplate] = useState([]);
	const {broadcastChannel} = usePusher()
	const new_incident_event = "permission_change"
	const user = useCurrentUser();

	async function getServiceTemplate(){
		return await axios.get("/service_template").then((res) => {
			const { data } = res.data;
			setServiceTemplate(formatData(data))
		}).catch((err) => {
			console.log(err)
		})
	}

	function formatData(data){
		return data.map((item) => {
			return {
				type: item?.type,
				issue: item?.issue_name,
				status_name: item?.status_name,
				id: item?.id,
				status: item.service_request_status?.status_name,
				status_details: {
					id: item.service_request_status?.id,
					label: item.service_request_status?.status_name,
					color: item.service_request_status?.status_color?.code,
				},
				priority: item.service_request_priority?.name,
				priority_details: {
					id: item?.service_request_priority?.id,
					label: item?.service_request_priority?.name,
					color: item?.service_request_priority?.priority_color?.code,
				},
				source: item?.service_request_source?.source_name,
				source_details: {
					id: item?.service_request_source?.id,
					label: item?.service_request_source?.source_name
				},
				category: item?.service_request_categories?.category_name,
				category_details: {
					id: item?.service_request_categories?.id,
					label: item?.service_request_categories?.category_name
				},
				subject: item?.subject,
				description: item?.description,
				files: item?.template_file?.length > 0 ? item?.template_file : []
			}
		})
	}

	function refreshList(){
		getServiceTemplate();
	}

	useEffect(()=>{
		setLoading(true)
		getServiceTemplate().finally(() => {
			setLoading(false)
		});
	},[]);
	useEffect(()=>{
		if(broadcastChannel/* && invoices.length*/){
			broadcastChannel.bind(new_incident_event, data => {
				if(data.user_companies_id == user.data.user_companies_id){
					location.reload();
				}
			})
			return () => broadcastChannel.unbind(new_incident_event)
		}
	},[broadcastChannel])

	if(loading){
		return(<FuseLoading />)
	} else {
		return (
			<>
				<FusePageCarded
					classes={{
						root: classes.layoutRoot,
						toolbar: 'p-0',
						topBg:classes.topBg,
						contentCard:classes.contentCard
					}}
					content={
						<>
							<div className={selectedTab !== 0 ? 'hidden' : ''}>
								{
									loading && <FuseLoading />
								}
								{
									!loading && <ListView 
										endUsersAccounts={serviceTemplate}
										refresh={refreshList}
									/>
								}
							</div>							
						</>
					}
					innerScroll
				/>
			</>
		)
	}
}

export default withReducer('serviceTemplateApp', reducer)(CardedFullWidth2TabbedSample);
